<template>
    <footer id="footer" class="bg-gray-800 py-1 px-5 text-white text-right bottom-0 left-0 right-0 z-3">
        Sponsors Management Platform Powered by <a target="_blank" href="https://www.bmotik.com"><b>Bmotik</b></a>
    </footer>
</template>

<style scoped>
#footer {
    box-shadow: 0 -5px 10px rgba(0,0,0,0.35);
}
</style>